import * as Yup from 'yup';

/**
 * Schema for the form
 */
export const baseGraphSetupValidationSchema = Yup.object().shape({
  graphTitle: Yup.string().required('Please provide a graph title.'),
  graphId: Yup.string()
    .min(1, 'Graph ID must be at least 2 characters')
    .max(64, 'Graph ID must be at most 64 characters')
    .matches(/^[a-zA-Z]/, 'Graph ID must start with a letter')
    .matches(
      /^[a-zA-Z0-9_-]*$/,
      'Graph ID may only contain letters, numbers, and dashes',
    )
    // starts with z-end-to-end- and !canCreateMonitoringService
    .required('Please provide a graph ID.'),
  accountId: Yup.string(),
});
